import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { AudioPlayerComponent } from '../../components/audio-player/audio-player.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-emotional-regulation',
  imports: [
    HeaderComponent,
    AudioPlayerComponent,
    TranslatePipe
],
  templateUrl: './emotional-regulation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './emotional-regulation.component.scss'
})
export class EmotionalRegulationComponent {
  
  configService: ConfigService = inject(ConfigService);

  back(){
    history.back();
  }

}
